import { Navigate, Route, Routes } from 'react-router-dom';
import CalendarPage from './CalendarPage';
import EventsPage from './EventsPage';
import SchedulePage from './SchedulePage';
import RoomsPage from './RoomsPage';

export default function CalendarRoutes() {
  return (
    <Routes>
      <Route index element={<CalendarPage />} />
      <Route path="events" element={<EventsPage />} />
      <Route path="schedule" element={<SchedulePage />} />
      <Route path="rooms" element={<RoomsPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
